import { getRuntimeEnvironment } from '@/lib/runtime';
import type { PrintOptions, PrintResult, Printer, RuntimeEnvironment } from './printTypes';
import { WebPrintService } from './WebPrintService';
import { ElectronPrintService } from './ElectronPrintService';

/**
 * Capa única de impresión.
 *
 * Los componentes React (POS, panel, etc.) siempre llaman a `PrintService`
 * y NUNCA acceden directamente a window.electronAPI ni a APIs del sistema.
 * Aquí se decide, según el entorno, si la impresión va por navegador o por Electron.
 */
export interface IPrintService {
  readonly runtime: RuntimeEnvironment;
  listPrinters(): Promise<Printer[]>;
  printHTML(html: string, options?: PrintOptions): Promise<PrintResult>;
  printTest(printerName?: string): Promise<PrintResult>;
  openCashDrawer(): Promise<PrintResult>;
}

class PrintServiceFacade implements IPrintService {
  readonly runtime: RuntimeEnvironment;
  private impl: WebPrintService | ElectronPrintService;

  constructor() {
    this.runtime = getRuntimeEnvironment();
    this.impl =
      this.runtime === 'ELECTRON' ? new ElectronPrintService() : new WebPrintService();
  }

  listPrinters(): Promise<Printer[]> {
    return this.impl.listPrinters();
  }

  printHTML(html: string, options?: PrintOptions): Promise<PrintResult> {
    return this.impl.printHTML(html, options);
  }

  printTest(printerName?: string): Promise<PrintResult> {
    return this.impl.printTest(printerName);
  }

  openCashDrawer(): Promise<PrintResult> {
    return this.impl.openCashDrawer();
  }
}

export const PrintService: IPrintService = new PrintServiceFacade();